import styled from 'styled-components';
import { neutralWhite, grayBgSubtle, primary200 } from '../../../themes/colors';
import { Icon } from '../../../icon';

export const EmptyComponentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 12px;
    background-color: ${neutralWhite};
    box-shadow: 0 2px 5px 0 rgba(32, 56, 87, 0.08);
    border-radius: 4px;
    padding: 16px;
`;

export const StyledIcon = styled(Icon)`
	font-size: 24px;
    background-color: ${grayBgSubtle};
    color: ${primary200};
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
`;
